var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t("requestToPay.new_req_to_pay"),
        icon: "icon-sent",
        noReturn: "",
        returnUrl: "/home/",
        pageClass: "rtp_request",
      },
    },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _vm.activateSpinner ? _c("spinner") : _vm._e(),
          _vm._v(" "),
          !_vm.activateSpinner
            ? _c(
                "div",
                { staticClass: "ml-3 mr-3" },
                [
                  _vm.rtpType === "unit"
                    ? _c(
                        "form-accordion",
                        {
                          attrs: {
                            title: _vm.$t("attachments.doc"),
                            isTitleUpperCase: false,
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _vm.typeFile === "1" &&
                                  _vm.attachments.length > 0
                                    ? _c(
                                        "div",
                                        [
                                          _vm._l(
                                            _vm.attachments,
                                            function (attachment, id) {
                                              return _c(
                                                "b-row",
                                                {
                                                  key:
                                                    _vm.attachmentName +
                                                    "_" +
                                                    id,
                                                  staticClass:
                                                    "align-items-center justify-content-start mx-0 px-0",
                                                },
                                                [
                                                  _c(
                                                    "b-col",
                                                    {
                                                      staticClass:
                                                        "form-group ml-0",
                                                      attrs: {
                                                        xl: "3",
                                                        cols: "7",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex justify-content-between",
                                                        },
                                                        [
                                                          _c("label", [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  attachment.AttachmentName
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex",
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa-light fa-download ml-3",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.view(
                                                                        id
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa-light fa-magnifying-glass ml-5",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.openDoc(
                                                                        id
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-button",
                                                    {
                                                      staticClass:
                                                        "mb-3 w-auto px-4",
                                                      attrs: {
                                                        variant: "primary",
                                                        round: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.clearInvoice(
                                                            id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.del_label"
                                                            )
                                                          ) +
                                                          "\n                "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            [
                                              _vm.isNorm("SRTP")
                                                ? _c(
                                                    "b-col",
                                                    {
                                                      staticClass: "form-group",
                                                      attrs: {
                                                        xl: "4",
                                                        cols: "4",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "b-form-checkbox",
                                                        {
                                                          model: {
                                                            value:
                                                              _vm.addDocToRTP,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.addDocToRTP =
                                                                $$v
                                                            },
                                                            expression:
                                                              "addDocToRTP",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "requestToPay.add_attachment_rtp"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.typeFile === "1"
                                    ? _c(
                                        "b-row",
                                        {
                                          staticClass: "justify-content-start",
                                        },
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              staticClass: "form-group",
                                              attrs: { cols: "12" },
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "w-auto px-4",
                                                  attrs: {
                                                    variant: "tertiary",
                                                    round: "",
                                                    disabled:
                                                      !_vm.canSendAttachment,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openImportAttachmentInvoice(
                                                        _vm.typeFile
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.fileIsFacturX
                                                          ? _vm.attachments
                                                              .length
                                                            ? _vm.$t(
                                                                "attachments.replace_facturx"
                                                              )
                                                            : _vm.$t(
                                                                "attachments.import_facturx"
                                                              )
                                                          : _vm.$t(
                                                              "attachments.import_doc"
                                                            )
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.isSmartphoneOS
                                            ? _c(
                                                "b-col",
                                                { staticClass: "form-group" },
                                                [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      staticClass:
                                                        "generalBottomButton",
                                                      attrs: { round: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.scanDocument(
                                                            $event
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "creation_forms.tke_doct_pctr"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("input", {
                                            key: _vm.refreshImport,
                                            staticClass:
                                              "item-input hiddenElementAllSize local-file-input",
                                            attrs: {
                                              accept: ".jpeg,.jpg,.png,.pdf",
                                              type: "file",
                                              disabled: !_vm.canSendAttachment,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.executeOCR(
                                                  $event,
                                                  "INVOICE"
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("input", {
                                            staticClass: "hiddenElementAllSize",
                                            attrs: {
                                              type: "text",
                                              disabled: _vm.canSendAttachment,
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("input", {
                                            staticClass: "hiddenElementAllSize",
                                            attrs: {
                                              type: "text",
                                              id: "recommendation-list-input",
                                              disabled: _vm.canSendAttachment,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  this.attachments.length
                                    ? _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              staticClass: "form-group",
                                              attrs: { sm: "6" },
                                            },
                                            [
                                              _vm.typeFile === "2"
                                                ? _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.attachmentId,
                                                          expression:
                                                            "attachmentId",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        disabled:
                                                          !_vm.canSendAttachment,
                                                      },
                                                      on: {
                                                        change: [
                                                          function ($event) {
                                                            var $$selectedVal =
                                                              Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function (o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function (
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                            _vm.attachmentId =
                                                              $event.target
                                                                .multiple
                                                                ? $$selectedVal
                                                                : $$selectedVal[0]
                                                          },
                                                          function ($event) {
                                                            return _vm.cloudFileSel()
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "",
                                                            default: "",
                                                            disabled: "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                this
                                                                  .hasCloudAttachments
                                                                  ? _vm.$t(
                                                                      "creation_forms.slct_a_fl"
                                                                    )
                                                                  : _vm.$t(
                                                                      "attachments.no_document"
                                                                    )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.cloudDocsPicker,
                                                        function (cloudDoc) {
                                                          return _c(
                                                            "option",
                                                            {
                                                              key: cloudDoc.id,
                                                              domProps: {
                                                                value:
                                                                  cloudDoc.id,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    " +
                                                                  _vm._s(
                                                                    cloudDoc.name
                                                                  ) +
                                                                  "\n                  "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.rtpType === "unit"
                    ? _c("hr", { staticClass: "mx-auto" })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "form-accordion",
                    {
                      staticClass: "group-border p-0 m-0",
                      class: _vm.showOptions ? "" : " mb-5",
                      attrs: {
                        title:
                          _vm.rtpType === "group"
                            ? _vm.$t("creation_forms.dbtrs_info")
                            : _vm.$t("creation_forms.dbtr_info"),
                        isTitleUpperCase: false,
                      },
                    },
                    _vm._l(_vm.enteredDebtors, function (debtor, debtorIndex) {
                      return _c(
                        "b-row",
                        { key: debtor.debtorId },
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-row",
                                { staticClass: "justify-content-start" },
                                [
                                  _vm.isDebtorAnonymous(debtor)
                                    ? [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass:
                                              "text-center justify-content-between",
                                            attrs: {
                                              cols: "5",
                                              xl: "3",
                                              "align-self": "center",
                                            },
                                          },
                                          [
                                            _c(
                                              "b-row",
                                              [
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass: "pr-0",
                                                    attrs: {
                                                      cols: "6",
                                                      "align-self": "center",
                                                      "text-align": "left",
                                                    },
                                                  },
                                                  [
                                                    _c("p", [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "requestToPay.anon_debtor"
                                                            )
                                                          ) +
                                                          "\n                        "
                                                      ),
                                                      _vm.enteredDebtors
                                                        .length > 1
                                                        ? _c("span", [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  (
                                                                    parseInt(
                                                                      debtor.debtorId
                                                                    ) + 1
                                                                  ).toString()
                                                                ) +
                                                                "\n                        "
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass: "pl-1",
                                                    attrs: {
                                                      cols: "6",
                                                      "align-self": "center",
                                                      "text-align": "left",
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-light fa-check text-success",
                                                    }),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    : [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "form-group",
                                            attrs: {
                                              cols: "12",
                                              sm: "6",
                                              md: "4",
                                              xl:
                                                _vm.rtpType === "group"
                                                  ? "3"
                                                  : "4",
                                            },
                                          },
                                          [
                                            _c(
                                              "form-contact-dropdown-label-input",
                                              {
                                                attrs: {
                                                  isMandatory: "",
                                                  id:
                                                    "debtor-name-" +
                                                    debtorIndex.toString(),
                                                  labelClass: "mb-0",
                                                  inputIcon:
                                                    "fa fa-magnifying-glass",
                                                  inputLabel:
                                                    _vm.$t(
                                                      "common.debtor_name"
                                                    ),
                                                  placeholderValue:
                                                    _vm.$t("common.nme"),
                                                  mandatoryErrorIndicator:
                                                    _vm.beneficiaireError,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    debtor.debtorSelected = false
                                                  },
                                                  "change-iban": function (
                                                    $event
                                                  ) {
                                                    debtor.debtorBank = $event
                                                  },
                                                  "change-identifier":
                                                    function ($event) {
                                                      debtor.debtorEmail =
                                                        $event
                                                    },
                                                  "change-contact": function (
                                                    $event
                                                  ) {
                                                    return _vm.changeContact(
                                                      $event,
                                                      debtor,
                                                      debtorIndex
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: debtor.debtorName,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      debtor,
                                                      "debtorName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "debtor.debtorName",
                                                },
                                              }
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "form-group",
                                            attrs: {
                                              cols: "12",
                                              sm: "6",
                                              md: "4",
                                            },
                                          },
                                          [
                                            _c("form-write-group-label-input", {
                                              attrs: {
                                                isMandatory: "",
                                                id:
                                                  "debtor-srtp-id-iban-" +
                                                  debtorIndex.toString(),
                                                labelClass: "mb-0",
                                                inputLabel: _vm.$t(
                                                  "common.rtp_dbtr_ibn"
                                                ),
                                                disabled:
                                                  debtor.debtorSelected ||
                                                  (debtor.debtorSelected &&
                                                    debtor.debtorImportedFound),
                                                specificErrorIndicator:
                                                  _vm.ibanFormatError,
                                                specificMessage: _vm.$t(
                                                  "errors.invld_iban_frmt"
                                                ),
                                              },
                                              on: {
                                                blur: function ($event) {
                                                  return _vm.checkIBANFormat(
                                                    debtor.debtorBank
                                                  )
                                                },
                                              },
                                              model: {
                                                value: debtor.debtorBank,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    debtor,
                                                    "debtorBank",
                                                    $$v
                                                  )
                                                },
                                                expression: "debtor.debtorBank",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "form-group",
                                            attrs: {
                                              cols: "12",
                                              sm: "6",
                                              md: "4",
                                              xl:
                                                _vm.rtpType === "group"
                                                  ? "3"
                                                  : "4",
                                            },
                                          },
                                          [
                                            _c("form-write-group-label-input", {
                                              attrs: {
                                                isMandatory: "",
                                                id:
                                                  "debtor-srtp-id-provider-" +
                                                  debtorIndex.toString(),
                                                labelClass: "mb-0",
                                                inputLabel: _vm.$t(
                                                  "common.recipient_srtp_id_provider"
                                                ),
                                                disabled:
                                                  debtor.debtorSelected ||
                                                  (debtor.debtorSelected &&
                                                    debtor.debtorImportedFound),
                                                tooltipLabel: _vm.debtorHasNorm
                                                  ? undefined
                                                  : _vm.$t(
                                                      "common.id_provider_tooltip"
                                                    ),
                                                specificErrorIndicator:
                                                  _vm.isNorm("NONE") ||
                                                  _vm.isNorm("FORBIDDEN"),
                                                specificMessage: _vm.isNorm(
                                                  "FORBIDDEN"
                                                )
                                                  ? _vm.$t(
                                                      "errors.no_norm_allowed"
                                                    )
                                                  : _vm.$t(
                                                      "errors.no_norm_found_for_identifier"
                                                    ),
                                              },
                                              on: {
                                                blur: function ($event) {
                                                  return _vm.changeDebtorIdProvider(
                                                    debtor
                                                  )
                                                },
                                              },
                                              model: {
                                                value: debtor.debtorIdProvider,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    debtor,
                                                    "debtorIdProvider",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "debtor.debtorIdProvider",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                  _vm._v(" "),
                                  _vm.rtpType === "group"
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group pl-2 mb-0",
                                          attrs: { xl: "2", cols: "6" },
                                        },
                                        [
                                          _c("form-write-group-label-input", {
                                            attrs: {
                                              id:
                                                "debtor-amount-" +
                                                debtorIndex.toString(),
                                              isMandatory:
                                                !_vm.amountModifAccepted,
                                              labelClass: "mb-0",
                                              inputType: "number",
                                              inputLabel:
                                                _vm.$t("common.due_amnt") +
                                                " " +
                                                _vm.zoneCodeToSign(
                                                  _vm.zoneCode
                                                ),
                                              placeholderValue:
                                                _vm.$t("common.due_amnt"),
                                              typingDone: _vm.changeAmountTotal,
                                              disabled:
                                                _vm.enteredDebtors.length > 1 &&
                                                parseInt(debtor.debtorId) ===
                                                  _vm.enteredDebtors.length - 1,
                                            },
                                            model: {
                                              value: debtor.amount,
                                              callback: function ($$v) {
                                                _vm.$set(debtor, "amount", $$v)
                                              },
                                              expression: "debtor.amount",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isDebtorAnonymous(debtor)
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group mb-0",
                                          attrs: { cols: "2" },
                                        },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "col-1 fa fa-times-circle text-danger fs-25px mt-30px cursor",
                                            on: {
                                              click: function ($event) {
                                                return _vm.cancelDebtor(debtor)
                                              },
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _vm.debugQRCode && debtor.debtorToken !== ""
                                    ? [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass:
                                              "fs-9px color-col-recipient",
                                            attrs: { cols: "6" },
                                          },
                                          [
                                            _c("b", [_vm._v("Token: ")]),
                                            _vm._v(
                                              " " +
                                                _vm._s(debtor.debtorToken) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.showOptions && _vm.debtorHasNorm
                    ? _c("hr", { staticClass: "mx-auto" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.debtorHasNorm
                    ? _c(
                        "form-accordion",
                        {
                          attrs: {
                            id: "payment-details",
                            title: _vm.$t(
                              "common.formsSubTitle.rqst_to_pay_dtls"
                            ),
                            isTitleUpperCase: false,
                          },
                        },
                        [
                          _c(
                            "b-row",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      inputType: "text",
                                      maxLength: 35,
                                      colLabelSize: 4,
                                      colInputSize: 8,
                                      labelClass: "mb-0",
                                      inputLabel: _vm.$t("common.invc_ref"),
                                      placeholderValue:
                                        _vm.$t("common.invc_ref"),
                                      tooltipLabel: _vm.$t(
                                        "common.invc_ref_tooltip"
                                      ),
                                    },
                                    model: {
                                      value: _vm.invoiceReference,
                                      callback: function ($$v) {
                                        _vm.invoiceReference = $$v
                                      },
                                      expression: "invoiceReference",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.isNorm("SRTP")
                                ? _c(
                                    "b-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          inputType: "text",
                                          maxLength: 2041,
                                          colLabelSize: 4,
                                          colInputSize: 8,
                                          labelClass: "mb-0",
                                          inputLabel: _vm.$t("common.uri"),
                                          placeholderValue:
                                            _vm.$t("common.uri"),
                                        },
                                        model: {
                                          value: _vm.uri,
                                          callback: function ($$v) {
                                            _vm.uri = $$v
                                          },
                                          expression: "uri",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("b-col", { attrs: { cols: "4" } }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.hasRight("rtp_group_create")
                            ? _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "pb-3",
                                      attrs: { xl: "3", cols: "12" },
                                    },
                                    [
                                      _c(
                                        "b-form-radio-group",
                                        {
                                          model: {
                                            value: _vm.rtpType,
                                            callback: function ($$v) {
                                              _vm.rtpType = $$v
                                            },
                                            expression: "rtpType",
                                          },
                                        },
                                        [
                                          _c(
                                            "b-form-radio",
                                            {
                                              attrs: {
                                                name: "rtpType-radio",
                                                value: "unit",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("common.tab_unit")
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-radio",
                                            {
                                              attrs: {
                                                name: "rtpType-radio",
                                                value: "group",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("common.tab_group")
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3 mb-md-0",
                                  attrs: {
                                    cols: "12",
                                    sm: "6",
                                    md: "4",
                                    xl: "4",
                                  },
                                },
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      inputType: "text",
                                      maxLength: 140,
                                      colLabelSize: 4,
                                      colInputSize: 8,
                                      labelClass: "mb-0",
                                      inputLabel: _vm.$t("common.rsn"),
                                      placeholderValue: _vm.$t(
                                        "common.enter_reason"
                                      ),
                                    },
                                    model: {
                                      value: _vm.remittanceInformation,
                                      callback: function ($$v) {
                                        _vm.remittanceInformation = $$v
                                      },
                                      expression: "remittanceInformation",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3 mb-sm-0",
                                  attrs: {
                                    cols: "12",
                                    sm: "6",
                                    md: "4",
                                    xl: "4",
                                  },
                                },
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      isMandatory: "",
                                      isNotZero: "",
                                      inputType: "number",
                                      colLabelSize: 4,
                                      colInputSize: 8,
                                      minValue: 0,
                                      labelClass: "mb-0",
                                      inputLabel:
                                        _vm.$t("common.amnt_ttl_rtp") +
                                        " " +
                                        _vm.zoneCodeToSign(_vm.zoneCode),
                                      placeholderValue:
                                        _vm.$t("common.amnt_ttl_rtp") +
                                        " " +
                                        _vm.zoneCodeToSign(_vm.zoneCode),
                                      specificErrorIndicator:
                                        _vm.maxAmountError,
                                      specificMessage: _vm.maxAmountError
                                        ? _vm.$t(_vm.maxAmountErrorText, {
                                            maxAmount: _vm.maxAmount,
                                          })
                                        : _vm.$t("errors.amnt_ttl_chngd"),
                                    },
                                    on: { blur: _vm.changeDebtorsAmount },
                                    model: {
                                      value: _vm.amountTotal,
                                      callback: function ($$v) {
                                        _vm.amountTotal = $$v
                                      },
                                      expression: "amountTotal",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    sm: "6",
                                    md: "4",
                                    xl: "4",
                                  },
                                },
                                [
                                  _c("select-bank-account", {
                                    attrs: {
                                      labelClass: "mb-0",
                                      inputClass:
                                        "d-flex align-items-center icon-input bank-account-icon",
                                      inputIcon:
                                        "fa-solid fa-building-columns text-info",
                                    },
                                    model: {
                                      value: _vm.creditorBank,
                                      callback: function ($$v) {
                                        _vm.creditorBank = $$v
                                      },
                                      expression: "creditorBank",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.rtpType === "group"
                            ? _c(
                                "b-row",
                                { staticClass: "my-2" },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { xl: "3", cols: "6" } },
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          isMandatory: "",
                                          labelClass: "mb-0",
                                          inputType: "number",
                                          minValue: 2,
                                          maxValue: 10,
                                          inputLabel:
                                            _vm.$t("common.nbr_debtor"),
                                          placeholderValue:
                                            _vm.$t("common.nbr_debtor"),
                                        },
                                        model: {
                                          value: _vm.nbDebtors,
                                          callback: function ($$v) {
                                            _vm.nbDebtors = $$v
                                          },
                                          expression: "nbDebtors",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.debtorHasNorm
                    ? _c("hr", { staticClass: "mx-auto mt-5" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.debtorHasNorm && _vm.isNorm("SRTP")
                    ? _c(
                        "form-accordion",
                        {
                          attrs: {
                            id: "payment-terms",
                            title: _vm.$t(
                              "common.formsSubTitle.rqst_to_pay_terms"
                            ),
                            isTitleUpperCase: false,
                          },
                        },
                        [
                          _c(
                            "b-row",
                            { staticClass: "form-group removeJustifyOnXL" },
                            [
                              _vm.isNorm("SRTP")
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "mt-3 pr-2",
                                      attrs: { xl: "2", cols: "2" },
                                    },
                                    [
                                      _c(
                                        "b-form-checkbox",
                                        {
                                          model: {
                                            value: _vm.acceptNow,
                                            callback: function ($$v) {
                                              _vm.acceptNow = $$v
                                            },
                                            expression: "acceptNow",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("requestToPay.accept_now")
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.acceptNow && _vm.isNorm("SRTP")
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group",
                                      attrs: { cols: "4", lg: "3", xl: "2" },
                                    },
                                    [
                                      _c("datetime-picker-custom", {
                                        staticClass: "z-1",
                                        attrs: {
                                          isMandatory: "",
                                          format: "DD/MM/YYYY H:i:s",
                                          customInputClass: "form-control",
                                          customLabelClass: "mb-0",
                                          inputLabel:
                                            _vm.$t("requestToPay.accept_with") +
                                            " " +
                                            _vm.$t(
                                              "common.expiration_date_label"
                                            ),
                                          maxLength: 19,
                                          placeholderValue: _vm.$t(
                                            "common.datetime_picker_empty_date"
                                          ),
                                          inputIcon:
                                            "fa-solid fa-calendar pl-2",
                                        },
                                        model: {
                                          value: _vm.expirationDate,
                                          callback: function ($$v) {
                                            _vm.expirationDate = $$v
                                          },
                                          expression: "expirationDate",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("b-col", { attrs: { lg: "7", xl: "8" } }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.multiInstallments
                            ? _c(
                                "b-row",
                                {
                                  key: _vm.multiInstallments,
                                  staticClass: "form-group removeJustifyOnXL",
                                },
                                [
                                  !_vm.creditNote && _vm.isNorm("SRTP")
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "mt-3 pr-2",
                                          attrs: { cols: "2", xl: "2" },
                                        },
                                        [
                                          _c(
                                            "b-form-checkbox",
                                            {
                                              model: {
                                                value: _vm.payNow,
                                                callback: function ($$v) {
                                                  _vm.payNow = $$v
                                                },
                                                expression: "payNow",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("requestToPay.pay_now")
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm.creditNote
                                    ? _c("b-col", {
                                        staticClass: "mt-3 pr-2",
                                        attrs: { cols: "2", xl: "2" },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.payNow && _vm.isNorm("SRTP")
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: {
                                            cols: "4",
                                            lg: "3",
                                            xl: "2",
                                          },
                                        },
                                        [
                                          _c("datetime-picker-custom", {
                                            attrs: {
                                              isMandatory: "",
                                              format: "DD/MM/YYYY H:i:s",
                                              customInputClass: "form-control",
                                              customLabelClass: "mb-0",
                                              inputLabel:
                                                _vm.$t("common.pay_with") +
                                                " " +
                                                _vm.$t(
                                                  "common.execution_date_label"
                                                ),
                                              maxLength: 19,
                                              placeholderValue: _vm.$t(
                                                "common.datetime_picker_empty_date"
                                              ),
                                              inputIcon:
                                                "fa-solid fa-calendar pl-2",
                                            },
                                            model: {
                                              value: _vm.executionDate,
                                              callback: function ($$v) {
                                                _vm.executionDate = $$v
                                              },
                                              expression: "executionDate",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("b-col", { attrs: { lg: "7", xl: "8" } }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.creditNote
                            ? _c(
                                "b-row",
                                {
                                  staticClass:
                                    "form-group justify-content-start",
                                },
                                [
                                  _vm.isNorm("SRTP")
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "mt-3 pr-2 d-flex justify-content-between mb-3",
                                          attrs: {
                                            cols: "5",
                                            sm: "4",
                                            xl: "2",
                                          },
                                        },
                                        [
                                          _c(
                                            "b-form-checkbox",
                                            {
                                              model: {
                                                value: _vm.multiInstallments,
                                                callback: function ($$v) {
                                                  _vm.multiInstallments = $$v
                                                },
                                                expression: "multiInstallments",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "requestToPay.pay_installment"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.multiInstallments
                                            ? _c("label", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-plus pt-6px",
                                                  on: {
                                                    click: _vm.addInstallment,
                                                  },
                                                }),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span"),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.multiInstallments && _vm.isNorm("SRTP")
                                    ? _c(
                                        "b-col",
                                        {
                                          key: _vm.installmentRefresh,
                                          staticClass: "mt-3",
                                          attrs: {
                                            cols: "12",
                                            sm: "10",
                                            lg: "7",
                                          },
                                        },
                                        _vm._l(
                                          _vm.installments,
                                          function (
                                            installment,
                                            indexInstallment
                                          ) {
                                            return _c(
                                              "b-row",
                                              {
                                                key: indexInstallment,
                                                staticClass:
                                                  "form-group justify-content-start",
                                                class:
                                                  indexInstallment + 1 ===
                                                  _vm.installments.length
                                                    ? "mb-0"
                                                    : "",
                                              },
                                              [
                                                _c(
                                                  "b-col",
                                                  {
                                                    attrs: {
                                                      cols: "5",
                                                      xl: "4",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "datetime-picker-custom",
                                                      {
                                                        attrs: {
                                                          isMandatory: "",
                                                          format:
                                                            "DD/MM/YYYY H:i:s",
                                                          customInputClass:
                                                            "form-control",
                                                          customLabelClass:
                                                            "mb-0",
                                                          inputLabel:
                                                            _vm.$t(
                                                              "common.execution_date_label"
                                                            ) +
                                                            " " +
                                                            (indexInstallment +
                                                              1),
                                                          maxLength: 19,
                                                          placeholderValue:
                                                            _vm.$t(
                                                              "common.slct_date"
                                                            ),
                                                          inputIcon:
                                                            "fa-solid fa-calendar pl-2",
                                                        },
                                                        on: {
                                                          blur: _vm.changeDebtorsDate,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.installments[
                                                              indexInstallment
                                                            ].date,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.installments[
                                                                indexInstallment
                                                              ],
                                                              "date",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "installments[indexInstallment].date",
                                                        },
                                                      }
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass: "float-right",
                                                    attrs: { cols: "4" },
                                                  },
                                                  [
                                                    _c(
                                                      "form-write-group-label-input",
                                                      {
                                                        attrs: {
                                                          isMandatory: "",
                                                          inputType: "number",
                                                          colLabelSize: 12,
                                                          colInputSize: 12,
                                                          minValue: 0,
                                                          labelClass: "mb-0",
                                                          inputClass:
                                                            "installmentAmount",
                                                          inputLabel:
                                                            _vm.$t(
                                                              "common.amnt_installment_rtp"
                                                            ) +
                                                            " " +
                                                            (indexInstallment +
                                                              1) +
                                                            " " +
                                                            _vm.zoneCodeToSign(
                                                              _vm.zoneCode
                                                            ),
                                                          placeholderValue:
                                                            _vm.$t(
                                                              "common.amnt_installment_rtp"
                                                            ) +
                                                            " " +
                                                            (indexInstallment +
                                                              1) +
                                                            " " +
                                                            _vm.zoneCodeToSign(
                                                              _vm.zoneCode
                                                            ),
                                                          specificMessage:
                                                            _vm.$t(
                                                              "errors.amnt_ttl_chngd"
                                                            ),
                                                        },
                                                        on: {
                                                          blur: _vm.changeDebtorsAmount,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.installments[
                                                              indexInstallment
                                                            ].amount,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.installments[
                                                                indexInstallment
                                                              ],
                                                              "amount",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "installments[indexInstallment].amount",
                                                        },
                                                      }
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  { attrs: { cols: "1" } },
                                                  [
                                                    _vm.canDeleteInstallment
                                                      ? _c("i", {
                                                          staticClass:
                                                            "fa fa-times pt-26px",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.deleteInstallment(
                                                                indexInstallment
                                                              )
                                                            },
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.multiInstallments
                            ? _c(
                                "b-row",
                                {
                                  staticClass:
                                    "form-group justify-content-start",
                                },
                                [
                                  _vm.isNorm("SRTP") && !_vm.multiInstallments
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "mt-3 mr-5 pr-2",
                                          attrs: { xl: "4", cols: "4" },
                                        },
                                        [
                                          _c(
                                            "b-form-checkbox",
                                            {
                                              model: {
                                                value: _vm.creditNote,
                                                callback: function ($$v) {
                                                  _vm.creditNote = $$v
                                                },
                                                expression: "creditNote",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "requestToPay.credit_note"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { sm: "5", xl: "5" } },
                            [
                              _c(
                                "b-row",
                                { staticClass: "d-none" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group",
                                      attrs: {
                                        sm: "4",
                                        "offset-sm": "8",
                                        xl: "3",
                                        "offset-xl": "9",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-checkbox",
                                        {
                                          attrs: {
                                            value: 1,
                                            "unchecked-value": 0,
                                          },
                                          on: { change: _vm.changeInstPmt },
                                          model: {
                                            value: _vm.instantPayment,
                                            callback: function ($$v) {
                                              _vm.instantPayment = $$v
                                            },
                                            expression: "instantPayment",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "creation_forms.isSCTInst"
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.debtorHasNorm && _vm.isNorm("SRTP")
                    ? _c("hr", { staticClass: "mx-auto mt-5" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showOptions &&
                  (_vm.hasRight("rtp_option_amount_modify") ||
                    _vm.hasRight("rtp_option_multiple_dates_installment"))
                    ? _c(
                        "form-accordion",
                        {
                          attrs: {
                            title: _vm.$t(
                              "common.formsSubTitle.rqst_to_pay_sttngs"
                            ),
                            isTitleUpperCase: false,
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _vm.hasRight("rtp_option_amount_modify")
                                    ? _c(
                                        "b-form-checkbox",
                                        {
                                          staticClass: "mt-sm-2",
                                          attrs: {
                                            disabled: _vm.creditNote,
                                            value: true,
                                            "unchecked-value": false,
                                          },
                                          model: {
                                            value: _vm.amountModifAccepted,
                                            callback: function ($$v) {
                                              _vm.amountModifAccepted = $$v
                                            },
                                            expression: "amountModifAccepted",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "creation_forms.dbtr_may_ngtt_amnt"
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hasRight("rtp_option_date_modify") &&
                                  _vm.isNorm("SRTP")
                                    ? _c(
                                        "b-form-checkbox",
                                        {
                                          staticClass: "mt-sm-2",
                                          attrs: {
                                            disabled: _vm.creditNote,
                                            value: true,
                                            "unchecked-value": false,
                                          },
                                          model: {
                                            value: _vm.dateModifAccepted,
                                            callback: function ($$v) {
                                              _vm.dateModifAccepted = $$v
                                            },
                                            expression: "dateModifAccepted",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "creation_forms.dbtr_may_chng_date"
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  /*hasRight('rtp_option_reason_modify') A DECOMMENTE DES QUE LE DROIT EXISTERA*/ _vm.isNorm(
                                    "HRTP"
                                  )
                                    ? _c(
                                        "b-form-checkbox",
                                        {
                                          staticClass: "mt-sm-2",
                                          attrs: {
                                            disabled: _vm.creditNote,
                                            value: true,
                                            "unchecked-value": false,
                                          },
                                          model: {
                                            value: _vm.reasonModifAccepted,
                                            callback: function ($$v) {
                                              _vm.reasonModifAccepted = $$v
                                            },
                                            expression: "reasonModifAccepted",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "creation_forms.dbtr_may_chng_rson"
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group d-none",
                                  attrs: { id: "settings-delay", sm: "6" },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("common.acceptance")) +
                                      ": "
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    { attrs: { id: "settings-delay-accept" } },
                                    [
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            name: "acceptance-radio",
                                            value: "now",
                                          },
                                          model: {
                                            value: _vm.doesAcceptNow,
                                            callback: function ($$v) {
                                              _vm.doesAcceptNow = $$v
                                            },
                                            expression: "doesAcceptNow",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("common.accept_now")
                                              ) +
                                              "\n                "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.acceptExpirationTime,
                                                expression:
                                                  "acceptExpirationTime",
                                              },
                                            ],
                                            staticClass: "miniFormControl",
                                            attrs: {
                                              disabled:
                                                _vm.doesAcceptNow !== "now",
                                              type: "text",
                                              id: "settings-delay-accept-time",
                                            },
                                            domProps: {
                                              value: _vm.acceptExpirationTime,
                                            },
                                            on: {
                                              input: [
                                                function ($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.acceptExpirationTime =
                                                    $event.target.value
                                                },
                                                function ($event) {
                                                  _vm.acceptExpirationTime =
                                                    isNaN(
                                                      parseInt(
                                                        _vm.acceptExpirationTime
                                                      )
                                                    )
                                                      ? 1
                                                      : parseInt(
                                                          _vm.acceptExpirationTime
                                                        ) <= 0
                                                      ? 1
                                                      : parseInt(
                                                          _vm.acceptExpirationTime
                                                        )
                                                },
                                              ],
                                            },
                                          }),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("common.after_sent")
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            name: "acceptance-radio",
                                            value: "later",
                                          },
                                          model: {
                                            value: _vm.doesAcceptNow,
                                            callback: function ($$v) {
                                              _vm.doesAcceptNow = $$v
                                            },
                                            expression: "doesAcceptNow",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("common.accept_later")
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("requestToPay.payment")) +
                                      ": "
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    { attrs: { id: "settings-delay-pay" } },
                                    [
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            name: "payment-radio",
                                            value: "none",
                                          },
                                          on: {
                                            change: function ($event) {
                                              _vm.isSCTInst = false
                                            },
                                          },
                                          model: {
                                            value: _vm.doesPayNow,
                                            callback: function ($$v) {
                                              _vm.doesPayNow = $$v
                                            },
                                            expression: "doesPayNow",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("common.no_mr_payment")
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            name: "payment-radio",
                                            value: "now",
                                          },
                                          model: {
                                            value: _vm.doesPayNow,
                                            callback: function ($$v) {
                                              _vm.doesPayNow = $$v
                                            },
                                            expression: "doesPayNow",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("common.aftr_accpt")
                                              ) +
                                              "\n                "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.payExpirationTime,
                                                expression: "payExpirationTime",
                                              },
                                            ],
                                            staticClass: "miniFormControl",
                                            attrs: {
                                              disabled:
                                                _vm.doesPayNow !== "now",
                                              type: "text",
                                              id: "settings-delay-pay-time",
                                            },
                                            domProps: {
                                              value: _vm.payExpirationTime,
                                            },
                                            on: {
                                              input: [
                                                function ($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.payExpirationTime =
                                                    $event.target.value
                                                },
                                                function ($event) {
                                                  _vm.payExpirationTime = isNaN(
                                                    parseInt(
                                                      _vm.payExpirationTime
                                                    )
                                                  )
                                                    ? 1
                                                    : parseInt(
                                                        _vm.payExpirationTime
                                                      ) <= 0
                                                    ? 1
                                                    : parseInt(
                                                        _vm.payExpirationTime
                                                      )
                                                },
                                              ],
                                            },
                                          }),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("common.after_hours")
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            name: "payment-radio",
                                            value: "later",
                                          },
                                          on: {
                                            change: function ($event) {
                                              _vm.isSCTInst = false
                                            },
                                          },
                                          model: {
                                            value: _vm.doesPayNow,
                                            callback: function ($$v) {
                                              _vm.doesPayNow = $$v
                                            },
                                            expression: "doesPayNow",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("common.payment_later")
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c("span", { staticClass: "color-red" }, [
                          _vm._v(
                            "* " + _vm._s(_vm.$t("common.required_fields"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.debtorHasNorm
                        ? _c(
                            "div",
                            { staticClass: "justify-content-end" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mr-5",
                                  attrs: { variant: "tertiary" },
                                  on: { click: _vm.resetForm },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "d-none d-xl-inline" },
                                    [_vm._v(_vm._s(_vm.$t("common.rst")))]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "d-xl-none" }, [
                                    _vm._v(_vm._s(_vm.$t("common.rst"))),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  key: _vm.sendPaymentsButtonKey,
                                  staticClass: "mr-3",
                                  attrs: { variant: "primary", size: "sm" },
                                  on: { click: _vm.sendPayments },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "d-none d-xl-inline" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("creation_forms.snd_req"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "d-xl-none" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("creation_forms.snd"))
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }